
























import { Vue, Component, Emit, Watch, Prop } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class FilterQuality extends Vue {
  @Prop({ default: 'onlyQualityProblems' }) quality!: string;

  T = T;
  currentQuality = this.quality;

  qualityValues: { [key: string]: { name: string; id: string } } = {
    allProblems: {
      name: T.qualityFormQualityAny,
      id: 'all',
    },
    onlyQualityProblems: {
      name: T.qualityFormQualityOnly,
      id: 'onlyQualityProblems',
    },
  };

  @Emit('change')
  @Watch('currentQuality')
  onCurrentQualityChanged(val: string | null) {
    return val;
  }
}
